import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';
import { debounce } from 'lodash';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { calculatePeriodValueBaseOnPreviousPeriod, PERIODS_OPERATION_TYPES, summarizeSubtractPeriodValues } from 'components/BusinessToolForm/utils/helpers';

import { observedFields } from '../../utils/form';

export const useGetRetainedEarningsCalculation = () => {
  const { setValue } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKETING_AND_SALES.SALES_PLAN,
  );

  const [retainedEarningsFiled] = observedFields.retainedEarnings.setCalculatedValueFieldNames;

  const getRetainedEarningsCalculationHandler = useMemo(
    () =>
      debounce((content) => {
        if (!canAccess) return;
        
        const [initialEarnings, netIncome, financialActivitiesTable] = content;
        const calculatedEarnings = summarizeSubtractPeriodValues([netIncome, financialActivitiesTable[1]], PERIODS_OPERATION_TYPES.ADD);
        const retainedEarnings = calculatePeriodValueBaseOnPreviousPeriod(
          calculatedEarnings,
          initialEarnings,
        );  

        setValue(retainedEarningsFiled, retainedEarnings);
      }, 500),
     
    [],
  );

  return getRetainedEarningsCalculationHandler;
};
